/**
 * Polygon convexity classifier.
 */
export var Convexity;
(function (Convexity) {
    Convexity[Convexity["ILLEGAL"] = -1] = "ILLEGAL";
    Convexity[Convexity["COLINEAR"] = 0] = "COLINEAR";
    Convexity[Convexity["CONVEX"] = 1] = "CONVEX";
    Convexity[Convexity["CONCAVE"] = 2] = "CONCAVE";
})(Convexity || (Convexity = {}));
